import { Link } from "react-router-dom";
import Table from "../../core/common/dataTable/index";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { all_routes } from "../router/all_routes";
import Swal from "sweetalert2";
import useApi from "../../core/customhook/useApi";
import {  IsHrHead } from "../../environment";

const ViewApplicationRequisition = () => {
  // const isHod = IsHod === "true";
  // const isHrHead = IsHrHead === "true";

  const linkNavigation = `/view-requisition`;

  const columns = [
    {
      title: "MPR Id",
      dataIndex: "id",
      sorter: (a: any, b: any) => a.id.localeCompare(b.id),
      render: (id: string) => (
        <Link
          to={`${linkNavigation}/${id}`}
          className="text-nowrap"
          style={{
            textDecoration: "underline",
            color: "#0d6efd",
            fontWeight: 500,
            backgroundColor: "#e7f1ff",
            padding: "2px 4px",
            borderRadius: "4px",
          }}
        >
          {id}
        </Link>
      ),

      width: 100,
      fixed: "left",
    },
    {
      title: "Position Name",
      dataIndex: "positionName",
      sorter: (a: any, b: any) => a.positionName.localeCompare(b.positionName),
      width: 180,
      render: (_: string, record: any) => (
        <div className="text-nowrap">{_}</div>
      ),
    },
    {
      title: "Location",
      dataIndex: "location",
      sorter: (a: any, b: any) => a.location.localeCompare(b.location),
      width: 150,
    },
    {
      title: "CTC",
      dataIndex: "ctc",
      sorter: (a: any, b: any) => a.ctc - b.ctc, // assuming numeric CTC
      width: 100,
    },
    {
      title: "Action by",
      dataIndex: "",
      sorter: (a: any, b: any) => a.pendingOn.localeCompare(b.pendingOn),
      width: 150,
      render: (_: any, record: any) => {
        const name = record.actionby_name ?? "";
        const by = record.actioned_by ?? "";
        return (
          <div className="text-nowrap">{name ? `${name} (${by})` : by}</div>
        );
      },
    },
    {
      title: "Created on",
      dataIndex: "createdDate",
      sorter: (a: any, b: any) =>
        new Date(a.createdDate).getTime() - new Date(b.createdDate).getTime(),
      width: 160,
      render: (date: string) => {
        const formattedDate = new Date(date).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "long",
          year: "numeric",
        });

        return <span className="text-muted text-nowrap">{formattedDate}</span>;
      },
    },
    // {
    //   title: "Created By",
    //   dataIndex: "createdBy",
    //   sorter: (a: any, b: any) => a.createdBy.localeCompare(b.createdBy),
    //   width: 140,
    //   render: (text: string, record: any) => (
    //     <div className="text-nowrap">{text}</div>
    //   ),
    // },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a: any, b: any) => a.status.localeCompare(b.status),
      render: (status: string) => {
        let badgeClass = "";

        if (status === "Approved") badgeClass = "bg-success";
        else if (status === "Rejected") badgeClass = "bg-danger";
        else badgeClass = "bg-warning text-dark"; // Pending or any other

        return (
          <span
            className={`badge ${badgeClass}`}
            style={{
              fontSize: "12px",
              padding: "4px 10px",
              fontWeight: 500,
              minWidth: "80px",
              textAlign: "center",
              display: "inline-block",
            }}
          >
            {status}
          </span>
        );
      },
    },
    {
      title: "View MPR",
      key: "viewMpr",
      render: (record: any) => (
        <Link
          to={`${linkNavigation}/${record.id}`}
          style={{
            textDecoration: "underline",
            color: "#0d6efd",
            fontWeight: 500,
            backgroundColor: "#e7f1ff",
            padding: "2px 4px",
            borderRadius: "4px",
          }}
        >
          View MPR
        </Link>
      ),
      width: 120,
      // fixed: "right",
    },
    // {
    //   title: "Action",
    //   key: "viewMpr",
    //   render: (record: any) => (
    //     <Link
    //       to={`/man-power-recruitment`}
    //       className="text-nowrap btn btn-primary btn-sm"
    //       onClick={handleWithdrawn}
    //     >
    //       Withdraw
    //     </Link>
    //   ),
    //   width: 120,
    // },
  ];

  const { data: MprData } = useApi("/api/fetch-allmpr", {
    method: "GET",
    autoCall: true,
  });

  const handleWithdrawn = (e: React.MouseEvent) => {
    e.preventDefault(); // prevent Link navigation until confirmed

    Swal.fire({
      title: "Are you sure?",
      text: "This MPR will be withdrawn. This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, withdraw it",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        //call your API or logic here
        // withdrawMpr(record.id)

        Swal.fire({
          icon: "success",
          title: "Withdrawn!",
          text: "The MPR has been successfully withdrawn.",
          timer: 1500,
          showConfirmButton: false,
        });

        // navigate("/man-power-recruitment");
      }
    });
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">View Requisition Application</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.adminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Recruitment</li>
                <li className="breadcrumb-item active">Requisition Form</li>
              </ol>
            </nav>
          </div>

          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <CollapseHeader />
          </div>
        </div>
        {/* /Breadcrumb */}
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h5>Requisition Application</h5>
            <Link to={"/man-power-recruitment"}>
              <button className="btn btn-primary">Add Requisition</button>
            </Link>
          </div>
          <div className="card-body px-0">
            <Table
              dataSource={MprData?.data ?? ""}
              columns={columns}
              Selection={false}
            />
          </div>
        </div>
      </div>
      <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
        <p className="mb-0"> © {new Date().getFullYear()} WeConnect. All rights reserved.</p>
      </div>
    </div>
  );
};

export default ViewApplicationRequisition;
